import { useGetSelections } from "modules/ClientAccount/hooks"
import { Selections } from "modules/ClientAccount/components/Selections"
import { FAQContainer } from "modules/ClientAccount/components/index"
import { GoToSurveyCard } from "modules/ClientAccount/components/GoToCard"
import { Spinner } from "components/Spinner"
import { Text } from "ui-kit/components-branded/index"
import { ClientSurveyLink } from "app/AppRouter/links"
import { CertificateBlock, CourseBanner } from "components"

export const SelectionsContent = () => {
    const { data, isLoading } = useGetSelections()

    return (
        <>
            {!isLoading && data && data.length === 0 && (
                <>
                    {" "}
                    <GoToSurveyCard />
                    <div className="banner-mobile is-hidden-tablet">
                        <CertificateBlock />
                        <CourseBanner />
                    </div>
                </>
            )}
            {!isLoading && data && data.length > 0 && (
                <>
                    <Text className="is-block mgb-3">
                        Подборки основаны на&nbsp;ваших ответах в&nbsp;анкете и&nbsp;помогут
                        подобрать наиболее подходящего психолога.
                    </Text>
                    <ClientSurveyLink className="button-secondary client-account-selections-content__button">
                        <Text weight="medium">Подобрать психолога</Text>
                    </ClientSurveyLink>
                    <Selections items={data} />
                    <div className="banner-mobile is-hidden-tablet">
                        <CertificateBlock />
                        <CourseBanner />
                    </div>
                </>
            )}
            {isLoading && <Spinner />}
            <FAQContainer />
        </>
    )
}
